import { gql } from 'graphql-request';
import {
  MaterialID,
  MaterialImageFile,
  MaterialImageID,
  MaterialImageUUID,
  MaterialName,
  MaterialNanoID,
  MaterialUUID
} from '../materialsTypes';

export interface FetchSelectMaterialsQueryResponse {
  id: MaterialID;
  uuid: MaterialUUID;
  nanoId: MaterialNanoID;
  name: MaterialName;
  image: {
    id: MaterialImageID;
    uuid: MaterialImageUUID;
    file: MaterialImageFile;
  };
}

export const FETCH_SELECT_MATERIALS_QUERY = gql`
  query SelectMaterials(
    $filters: MaterialsFilters
    $sort: [MaterialsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    materials(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        id
        uuid
        nanoId
        createdAt
        name
        image {
          id
          uuid
          file
        }
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
